<template>
  <div class="fill flex column comments_container l8" :class="`comments_container_${commentsid}`" v-if="$store.state.app.basics.modules &&
    $store.state.app.basics.modules.indexOf('comments') > -1
  ">

    <div class="flex center" v-if="!$store.state.comments[assetId] ||
      Object.keys($store.state.comments[assetId] || {}).length === 0
    ">
      <a href @click.prevent="$store.state.show.auth = true" v-if="!$store.state.auth.uid">Login to think.</a>
      <div v-else>No thoughts yet.</div>
    </div>
    <div v-if="commentId && filteredComments.length === 0" class="flex center">
      <div>Comment not found: {{ commentId }}</div>
    </div>

    <!-- Load Previous Button -->
    <div v-if="hasMoreComments" class="flex center p4">
      <button @click="loadPreviousComments()" class="p4 r4 update-border xs-font"
        style="background: rgba(0, 123, 255, 0.1); cursor: pointer;">
        <i class="fas fa-chevron-up r4"></i>Load Previous
      </button>
    </div>

    <div :key="$store.state.counter + commentKey" v-for="(comment, commentKey) in filteredComments" :style="`opacity: ${Number(1 - 0.0625 * +depth)}; font-size: ${100 / Number(1 + 0.05 * +depth)
      }%;`">
      <div v-if="comment !== null &&
        (comment.published ||
          $store.state.app.user.includes($store.state.auth.uid) ||
          ($store.state.app.advanced.roles.admin &&
            $store.state.app.advanced.roles.admin.members &&
            $store.state.app.advanced.roles.admin.members.includes(
              $store.state.auth.uid
            )))
      " class="comment flex column wrap">
        <div class="flex flexy md-font column container t8">
          <div class="flex between align-center xs-font p4">


            <span class="flex" v-if="comment.user === $store.state.auth.uid">
              <i @click="
                openEditComment(comment)
                " class="fas fa-edit r4"></i>
            </span>
            <user :userid="comment.user"></user>


            <itime class="r8 update-text" :timestamp="comment.timestamp"></itime>
            <i @click="$router.push(`/comments/${commentsid}/${comment.id}`)" class="fas fa-external-link-alt r4"
              style="cursor: pointer; color: #666;" title="Open in new page"></i>
            <!-- <i v-if="comment.type" class="xs-font p4">{{ comment.type }}</i> -->

          </div>
          <!-- attachments -->
          <div v-if="$store.state.show.commentEdit !== comment.id">
            <!-- <short v-if="comment.text.length > 160 && !show.expand" @click="show.expand = true" :str="comment.text" len="140"/> -->
            <!-- Custom Comment Renderer (replaces icontent) -->
            <div :class="`comment_area comment_area_${comment.id}`" class="p4">
              <div v-if="comment.text" class="comment-text">
                <vue-markdown :content="comment.text"
                  :options="{ markdownIt: { linkify: true, inline: true, html: true } }" />
              </div>

              <!-- Render components -->
              <div v-if="comment.components && comment.components.length > 0" class="comment-components">
                <component v-for="(comp, idx) in comment.components" :key="idx" :is="comp.name" v-bind="comp.props"
                  :style="comp.styles" />
              </div>

              <!-- Render media -->
              <div v-if="comment.media && comment.media.length > 0" class="comment-media">
                  <div v-for="(mediaItem, index) in comment.media" :key="index" style="margin: 4px 0;">
                    <img :src="mediaItem" class="comment-media-item" style="max-width: 100%; height: auto; border-radius: 4px;" />
                  </div>
              </div>

              <!-- Render links -->
              <div v-if="comment.links && comment.links.length > 0" class="comment-links">
                <div v-for="(link, index) in comment.links" :key="index" class="comment-link">
                  <a :href="link" target="_blank" rel="noopener noreferrer" class="comment-link-item">
                    {{ link }}
                  </a>
                </div>
              </div>

              <!-- Render embeds -->
              <div v-if="comment.embeds" class="comment-embeds">
                <div v-html="processEmbed(comment.embeds)" ref="embedContainer"></div>
              </div>
            </div>
            <!-- <div class="xs-font">{{ comment }}</div> -->
          </div>
          
          <!-- Unified Comment Form - appears inline when editing this comment -->
          <div v-if="$store.state.show.commentEdit === comment.id" class="fill r4 p8" style="border-radius: 8px; margin-top: 8px;">
            <!-- Unified Post Area -->
            <div class="unified-post-area" @click="isFormActive = true">
              <!-- Text Section -->
              <div class="post-section">
                <textarea ref="editTextarea" class="flexw p4 dynamic-textarea" v-model="currentFormComment.text"
                  placeholder="Edit your thought..." @keydown="handleKeydown" @input="adjustTextareaHeight"
                  @focus="isFormActive = true; adjustTextareaHeight"
                  style="border-radius: 6px; resize: none; overflow-y: auto;"></textarea>
              </div>

              <!-- Action Buttons -->
              <div v-show="showActionButtons" class="flex align-center p4 xs-font " style="align-self: stretch">
                <button class="p4 update-border" type="button" @click="togglePickComponents"><i
                    class="update-text fa fa-cubes p4"></i></button>
                <button class="p4 update-border" type="button" @click="toggleLinks"><i
                    class="update-text fa fa-link p4"></i></button>
                <button class="p4 update-border" type="button" @click="toggleEmbeds"><i
                    class="update-text fa fa-code p4"></i></button>
                <media view="compact"  select v-model="currentFormComment.media" class="xs-font"></media>
                <button @click="show['preview'] = !show['preview']; if (show['preview']) processInstagramEmbeds()"
                  class="xs-font p4" type="button" style="border: 1px solid #ccc; background: #f8f9fa; border-radius: 4px;">
                  {{ show['preview'] ? 'Hide Preview' : 'Preview' }}
                </button>
              </div>

              <!-- Components Section -->
              <div v-if="show['pickComponents']" class="post-section">
                <label class="section-label">Widgets</label>
                <div class="flex wrap" v-for="(components, componentcategory) in $store.state.components"
                  :key="'edit-' + componentcategory">
                  <div class="indicate-text border-bottom">{{ componentcategory }}</div>
                  <div class="flex wrap align-center">
                    <span v-for="(comp, compkey) in components" :key="compkey" @click="addComponentToForm(comp)">
                      <span class="p4"><i v-if="'displayinstancewidgets'.indexOf(componentcategory) >= 0"
                          class="fa-sm fa fa-plus"></i>{{ comp }}</span>
                    </span>
                  </div>
                </div>

                <!-- Component Management UI -->
                <div v-if="currentFormComment.components && currentFormComment.components.length > 0" class="mt4">
                  <div v-for="(comp, cidx) in currentFormComment.components" :key="comp.name + cidx"
                    class="t8 container p8 indicate-border">
                    <div class="flex align-center between xs-font">
                      <div>
                        <i @click="moveComponent(currentFormComment.components, cidx, -1)" v-if="cidx > 0"
                          class="fa fa-arrow-up r4"></i>
                        <i @click="moveComponent(currentFormComment.components, cidx, 1)"
                          v-if="cidx < currentFormComment.components.length - 1" class="fa fa-arrow-down"></i>
                      </div>
                      <span @click="$set(show, 'editComp' + cidx, !show['editComp' + cidx])">
                        <b class="md-font align-center flex">
                          <i class="fa fa-box r4" />
                          {{ comp.name }}
                        </b>
                        <span class="update-text xs-font p4">
                          {{ getPropsSummary(comp.props) }}
                        </span>
                      </span>
                      <i class="fa fa-trash warn-text" @click="currentFormComment.components.splice(cidx, 1)"></i>
                    </div>
                    <div v-if="show['editComp' + cidx]" class="p4">
                      <div class="flex column">
                        <!-- New Prop Editor -->
                        <div class="p4 b8 r4">
                          <label class="xs-font">Component Props</label>
                          <select v-model="comp._selectedProp" @change="onPropSelect(comp)" class="xs-input">
                            <option :value="null">-- Select a prop to edit --</option>
                            <option v-for="(prop, propName) in $cp[comp.name]" :key="propName" :value="propName">
                              {{ propName }}
                            </option>
                          </select>

                          <div v-if="comp._selectedProp" class="p4">
                            <iinput :label="comp._selectedProp" :type="getPropInputType(comp.name, comp._selectedProp)"
                              v-model="comp._propValue" />
                            <button class="p4 update" type="button" @click="saveProp(comp)">Save Prop</button>
                          </div>
                        </div>

                        <!-- Style Editor -->
                        <div class="p4 b8 r4 mt8">
                          <label class="xs-font">Styles (JSON)</label>
                          <textarea v-model="comp._stylesText" class="xs-input" placeholder="styles as JSON"></textarea>
                          <button class="p4" type="button" @click="saveComponentStyles(comp)">Save Styles</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Links Section -->
              <div v-if="show['links']" class="post-section">
                <label class="section-label">Links</label>
                <state :statedata="currentFormComment.links" :editable="'true'" :createable="'true'" />
              </div>

              <!-- Embeds Section -->
              <div v-if="show['embeds']" class="post-section">
                <label class="section-label">Embeds</label>
                <textarea v-model="currentFormComment.embeds" placeholder="Paste embed code (iframe, script, etc.)"
                  class="flexw p4 r4 b4" style="min-height: 60px; border-radius: 6px; resize: vertical;"></textarea>
              </div>

              <!-- Media Section -->
              <div v-if="currentFormComment.media && currentFormComment.media.length > 0" class="post-section">
                <label class="section-label">Media</label>
                <div class="flex wrap align-center">
                  <div v-for="(mediaItem, index) in currentFormComment.media" :key="index" class="p4">
                    <img :src="mediaItem" class="thumbnail" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" />
                  </div>
                </div>
              </div>

              <!-- Preview Section -->
              <div v-if="show['preview']" class="post-section">
                <label class="section-label">Preview</label>
                <div class="preview-content p4 b8 r4">
                  <div v-if="currentFormComment.text" class="comment-text">
                    <vue-markdown :content="currentFormComment.text"
                      :options="{ markdownIt: { linkify: true, inline: true, html: true } }" />
                  </div>

                  <!-- Render components -->
                  <div v-if="currentFormComment.components && currentFormComment.components.length > 0"
                    class="comment-components">
                    <component v-for="(comp, idx) in currentFormComment.components" :key="idx" :is="comp.name"
                      v-bind="comp.props" :style="comp.styles" />
                  </div>

                  <!-- Render media -->
                  <div v-if="currentFormComment.media && currentFormComment.media.length > 0" class="comment-media">
                    <div v-for="(mediaItem, index) in currentFormComment.media" :key="index" style="margin: 4px 0;">
                      <img :src="mediaItem" class="comment-media-item" style="max-width: 100%; height: auto; border-radius: 4px;" />
                    </div>
                  </div>

                  <!-- Render links -->
                  <div v-if="currentFormComment.links && currentFormComment.links.length > 0" class="comment-links">
                    <div v-for="(link, index) in currentFormComment.links" :key="index" class="comment-link">
                      <a :href="link" target="_blank" rel="noopener noreferrer" class="comment-link-item">
                        {{ link }}
                      </a>
                    </div>
                  </div>

                  <!-- Render embeds -->
                  <div v-if="currentFormComment.embeds" class="comment-embeds">
                    <div v-html="processEmbed(currentFormComment.embeds)"></div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="showActionButtons" class="flex justify-end p4 align-center" style="gap: 8px;">
              <button @click="
                $store.commit('set', {
                  keys: ['show', 'commentEdit'],
                  val: false,
                });
              " class="p8 flex flexw align-center" style="border-radius: 6px; min-width: 100px; border: 1px solid #ccc; background: #f8f9fa;">
                Cancel
              </button>
              <button :disabled="!hasContentForCurrentForm" type="button" class="p8 update flex flexw align-center"
                style="border-radius: 6px; min-width: 100px;" @click="
                  update(editingComment);
                  $store.commit('set', {
                    keys: ['show', 'commentEdit'],
                    val: false,
                  });
                  show.pickComponents = false;
                  show.links = false;
                  show.embeds = false;
                  show.preview = false;
                ">
                <i class="fas fa-save r4"></i>Save Changes
              </button>
              <code v-if="editingComment && (editingComment.user === $store.state.auth.uid || ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members && $store.state.app.advanced.roles.admin.members.includes($store.state.auth.uid)))" @click="remove(commentsid || $route.params.assetId, editingComment.id)" class="flex align-center xs-font p8" style="cursor: pointer;">
                <i class="far fa-trash-alt r4"></i>Remove
              </code>
            </div>
          </div>
          <div class="flex between xs-font align-center l4 r4 comment-interactions"
            style="position: relative; z-index: 9; ">

              <reputation :key="$store.state.counter + comment.id" :fId="comment.id" f-type="comments"
                class="flex xs-font"></reputation>
              <label class="flex align-center" v-if="$store.state.app.user.includes($store.state.auth.uid) ||
                ($store.state.app.advanced.roles.admin &&
                  $store.state.app.advanced.roles.admin.members &&
                  $store.state.app.advanced.roles.admin.members.includes(
                    $store.state.auth.uid
                  ))
              ">
                <input :id="`comment-published-${comment.id}`" @change="update(comment, comment.id)" type="checkbox"
                  v-model="comment.published" />Published</label>

                <span @click="
                  loadReplies(comment.id);
                $store.commit('set', {
                  keys: ['responses', comment.id],
                  val: !$store.state.responses[comment.id],
                })
                  ">{{ getReplyCount(comment.id) > 0 ? `${getReplyCount(comment.id)}` : '' }} Thought{{
                  getReplyCount(comment.id) > 1
                    ? 's' : '' }}
                  <i :class="!$store.state.responses[comment.id]
                    ? 'fas fa-chevron-down r4'
                    : 'fas fa-chevron-up'
                    "></i></span>
                <button @click="toggleReplyForm(comment.id)" class="p4 flex align-center thought-button"
                  style="border: none; background: none; cursor: pointer; transition: all 0.3s ease;"
                  :class="{ 'active': show.replyToComment === comment.id }">
                  <i class="r4 fas fa-reply fa-rotate-90 fa-flip-vertical"> </i> thought?
                </button>


          </div>
        </div>
        <comments v-if="comment && $store.state.responses[comment.id]" :commentsid="comment.id"
          :depth="+depth + 1 || 1">
        </comments>

        <!-- Reply form for this specific comment -->
        <transition name="thought-box" appear>
          <div v-if="show.replyToComment === comment.id" class="fill b8 r4 thought-reply-form"
            style="border-radius: 8px; margin-top: 8px;">
            <div class="unified-post-area" @click="isFormActive = true">
              <!-- Text Section -->
              <div class="post-section">
                <textarea :id="`replyTextarea_${comment.id}`" :ref="`replyTextarea_${comment.id}`"
                  class="flexw p4 dynamic-textarea" v-model="newComment[comment.id].text"
                  placeholder="Write a thought..." @keydown="handleKeydown" @input="adjustTextareaHeight"
                  @focus="isFormActive = true; adjustTextareaHeight"
                  style="border-radius: 6px; resize: none; overflow-y: auto;"></textarea>
              </div>

              <!-- Action Buttons -->
              <div v-show="showActionButtons" class="flex align-center p4 xs-font " style="align-self: stretch">
                <button class="p4 update-border" type="button" @click="togglePickComponents"><i
                    class="update-text fa fa-cubes p4"></i></button>
                <button class="p4 update-border" type="button" @click="toggleLinks"><i
                    class="update-text fa fa-link p4"></i></button>
                <button class="p4 update-border" type="button" @click="toggleEmbeds"><i
                    class="update-text fa fa-code p4"></i></button>
                <media view="compact" select v-model="newComment[comment.id].media" class="xs-font"></media>
                <button @click="show['preview'] = !show['preview']; if (show['preview']) processInstagramEmbeds()"
                  class="xs-font p4" type="button"
                  style="border: 1px solid #ccc; background: #f8f9fa; border-radius: 4px;">
                  {{ show['preview'] ? 'Hide Preview' : 'Preview' }}
                </button>
              </div>

              <!-- Preview Section -->
              <div
                v-if="show['preview'] && (newComment[comment.id].text || (newComment[comment.id].components && newComment[comment.id].components.length > 0) || (newComment[comment.id].media && newComment[comment.id].media.length > 0))"
                class="post-section">
                <label class="section-label">Preview</label>
                <div class="preview-content p4 b8 r4">
                  <div v-if="newComment[comment.id].text" class="comment-text">
                    <vue-markdown :content="newComment[comment.id].text"
                      :options="{ markdownIt: { linkify: true, inline: true, html: true } }" />
                  </div>

                  <!-- Render components -->
                  <div v-if="newComment[comment.id].components && newComment[comment.id].components.length > 0"
                    class="comment-components">
                    <component v-for="(comp, idx) in newComment[comment.id].components" :key="idx" :is="comp.name"
                      v-bind="comp.props" :style="comp.styles" />
                  </div>

                  <!-- Render media -->
                  <div v-if="newComment[comment.id].media && newComment[comment.id].media.length > 0"
                    class="comment-media">
                    <div v-for="(mediaItem, index) in newComment[comment.id].media" :key="index" style="margin: 4px 0;">
                      <img :src="mediaItem" class="comment-media-item" style="max-width: 100%; height: auto; border-radius: 4px;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="showActionButtons" class="flex justify-end p4 align-center" style="gap: 8px;">
              <button :disabled="!hasContentForComment(comment.id)" type="button"
                class="p8 update flex flexw align-center" style="border-radius: 6px; min-width: 100px;"
                @click="post(comment.id, newComment[comment.id]); clearCommentData(comment.id); show.pickComponents = false; show.links = false; show.embeds = false; show.preview = false; show.replyToComment = null;">
                <i class="fas fa-paper-plane r4"></i>Post Thought
              </button>
            </div>
          </div>
        </transition>
      </div>
      <code v-if="comment && $store.state.responses[comment.id]" class="xs-font flex align-center b8" @click="
        $store.commit('setState', {
          prop: 'responses',
          prop2: comment.id,
          val: false,
        });
      $store.commit('setState', {
        prop: 'reply',
        prop2: comment.id,
        val: !$store.state.reply[comment.id],
      });
      ">
        <i class="fas fa-chevron-up r4 p8"></i>
      </code>
    </div>
    <!-- <button class="xs-font update-border" href @click="show.newComment = !show.newComment">respond to: <short len="9" str="comment.text"/></button> -->

    <!-- Unified Comment Form - for creating (only show when not editing any comment) -->
    <div v-if="(assetId ||
      $route.name === 'comments' ||
      $route.params.iitemid ||
      assetId === 'onboard') &&
      $store.state.auth.uid &&
      !editingCommentId
    " class="fill r4 p8" style="border-radius: 8px;">

      <!-- Unified Post Area -->
      <div class="unified-post-area" @click="isFormActive = true">
        <!-- Text Section -->
        <div class="post-section">
          <textarea :ref="editingComment ? 'editTextarea' : 'replyTextarea'" class="flexw p4 dynamic-textarea" v-model="currentFormComment.text"
            :placeholder="editingComment ? 'Edit your thought...' : 'Write a thought...'" @keydown="handleKeydown" @input="adjustTextareaHeight"
            @focus="isFormActive = true; adjustTextareaHeight"
            style="border-radius: 6px; resize: none; overflow-y: auto;"></textarea>
        </div>

        <!-- Action Buttons -->
        <div v-show="showActionButtons" class="flex align-center p4 xs-font " style="align-self: stretch">
          <button class="p4 update-border" type="button" @click="togglePickComponents"><i
              class="update-text fa fa-cubes p4"></i></button>
          <button class="p4 update-border" type="button" @click="toggleLinks"><i
              class="update-text fa fa-link p4"></i></button>
          <button class="p4 update-border" type="button" @click="toggleEmbeds"><i
              class="update-text fa fa-code p4"></i></button>
          <media view="compact" select v-model="currentFormComment.media" class="xs-font"></media>
          <button @click="show['preview'] = !show['preview']; if (show['preview']) processInstagramEmbeds()"
            class="xs-font p4" type="button" style="border: 1px solid #ccc; background: #f8f9fa; border-radius: 4px;">
            {{ show['preview'] ? 'Hide Preview' : 'Preview' }}
          </button>
        </div>

        <!-- Components Section -->
        <div v-if="show['pickComponents']" class="post-section">
          <label class="section-label">Widgets</label>
          <div class="flex wrap" v-for="(components, componentcategory) in $store.state.components"
            :key="'edit-' + componentcategory">
            <div class="indicate-text border-bottom">{{ componentcategory }}</div>
            <div class="flex wrap align-center">
              <span v-for="(comp, compkey) in components" :key="compkey" @click="addComponentToForm(comp)">
                <span class="p4"><i v-if="'displayinstancewidgets'.indexOf(componentcategory) >= 0"
                    class="fa-sm fa fa-plus"></i>{{ comp }}</span>
              </span>
            </div>
          </div>

          <!-- Component Management UI -->
          <div v-if="currentFormComment.components && currentFormComment.components.length > 0" class="mt4">
            <div v-for="(comp, cidx) in currentFormComment.components" :key="comp.name + cidx"
              class="t8 container p8 indicate-border">
              <div class="flex align-center between xs-font">
                <div>
                  <i @click="moveComponent(currentFormComment.components, cidx, -1)" v-if="cidx > 0"
                    class="fa fa-arrow-up r4"></i>
                  <i @click="moveComponent(currentFormComment.components, cidx, 1)"
                    v-if="cidx < currentFormComment.components.length - 1" class="fa fa-arrow-down"></i>
                </div>
                <span @click="$set(show, 'editComp' + cidx, !show['editComp' + cidx])">
                  <b class="md-font align-center flex">
                    <i class="fa fa-box r4" />
                    {{ comp.name }}
                  </b>
                  <span class="update-text xs-font p4">
                    {{ getPropsSummary(comp.props) }}
                  </span>
                </span>
                <i class="fa fa-trash warn-text" @click="currentFormComment.components.splice(cidx, 1)"></i>
              </div>
              <div v-if="show['editComp' + cidx]" class="p4">
                <div class="flex column">
                  <!-- New Prop Editor -->
                  <div class="p4 b8 r4">
                    <label class="xs-font">Component Props</label>
                    <select v-model="comp._selectedProp" @change="onPropSelect(comp)" class="xs-input">
                      <option :value="null">-- Select a prop to edit --</option>
                      <option v-for="(prop, propName) in $cp[comp.name]" :key="propName" :value="propName">
                        {{ propName }}
                      </option>
                    </select>

                    <div v-if="comp._selectedProp" class="p4">
                      <iinput :label="comp._selectedProp" :type="getPropInputType(comp.name, comp._selectedProp)"
                        v-model="comp._propValue" />
                      <button class="p4 update" type="button" @click="saveProp(comp)">Save Prop</button>
                    </div>
                  </div>

                  <!-- Style Editor -->
                  <div class="p4 b8 r4 mt8">
                    <label class="xs-font">Styles (JSON)</label>
                    <textarea v-model="comp._stylesText" class="xs-input" placeholder="styles as JSON"></textarea>
                    <button class="p4" type="button" @click="saveComponentStyles(comp)">Save Styles</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Links Section -->
        <div v-if="show['links']" class="post-section">
          <label class="section-label">Links</label>
          <state :statedata="currentFormComment.links" :editable="'true'" :createable="'true'" />
        </div>

        <!-- Embeds Section -->
        <div v-if="show['embeds']" class="post-section">
          <label class="section-label">Embeds</label>
          <textarea v-model="currentFormComment.embeds" placeholder="Paste embed code (iframe, script, etc.)"
            class="flexw p4 r4 b4" style="min-height: 60px; border-radius: 6px; resize: vertical;"></textarea>
        </div>

        <!-- Media Section -->
        <div v-if="currentFormComment.media && currentFormComment.media.length > 0" class="post-section">
          <label class="section-label">Media</label>
          <div class="flex wrap align-center">
            <div v-for="(mediaItem, index) in currentFormComment.media" :key="index" class="p4">
              <img :src="mediaItem" class="thumbnail" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" />
            </div>
          </div>
        </div>

        <!-- Preview Section -->
        <div v-if="show['preview']" class="post-section">
          <label class="section-label">Preview</label>
          <div class="preview-content p4 b8 r4">
              <div v-if="currentFormComment.text" class="comment-text">
              <vue-markdown :content="currentFormComment.text"
                :options="{ markdownIt: { linkify: true, inline: true, html: true } }" />
              </div>

            <!-- Render components -->
            <div v-if="currentFormComment.components && currentFormComment.components.length > 0"
              class="comment-components">
              <component v-for="(comp, idx) in currentFormComment.components" :key="idx" :is="comp.name"
                v-bind="comp.props" :style="comp.styles" />
            </div>

            <!-- Render media -->
            <div v-if="currentFormComment.media && currentFormComment.media.length > 0" class="comment-media">
              <div v-for="(mediaItem, index) in currentFormComment.media" :key="index" style="margin: 4px 0;">
                <img :src="mediaItem" class="comment-media-item" style="max-width: 100%; height: auto; border-radius: 4px;" />
              </div>
            </div>

            <!-- Render links -->
            <div v-if="currentFormComment.links && currentFormComment.links.length > 0" class="comment-links">
              <div v-for="(link, index) in currentFormComment.links" :key="index" class="comment-link">
                <a :href="link" target="_blank" rel="noopener noreferrer" class="comment-link-item">
                  {{ link }}
                </a>
              </div>
            </div>

            <!-- Render embeds -->
            <div v-if="currentFormComment.embeds" class="comment-embeds">
              <div v-html="processEmbed(currentFormComment.embeds)"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="showActionButtons" class="flex justify-end p4 align-center" style="gap: 8px;">
        <button v-if="editingComment" @click="
          $store.commit('set', {
            keys: ['show', 'commentEdit'],
            val: false,
          });
        " class="p8 flex flexw align-center" style="border-radius: 6px; min-width: 100px; border: 1px solid #ccc; background: #f8f9fa;">
          Cancel
        </button>
        <button :disabled="!hasContentForCurrentForm" type="button" class="p8 update flex flexw align-center"
          style="border-radius: 6px; min-width: 100px;" @click="
            if (editingComment) {
              update(editingComment);
              $store.commit('set', {
                keys: ['show', 'commentEdit'],
                val: false,
              });
              show.pickComponents = false;
              show.links = false;
              show.embeds = false;
              show.preview = false;
            } else {
              initCommentData(assetId);
              post(assetId, newComment[assetId]);
              clearCommentData(assetId);
              show.pickComponents = false;
              show.links = false;
              show.embeds = false;
              show.preview = false;
            }
          ">
          <i class="fas fa-paper-plane r4"></i>{{ editingComment ? 'Save Changes' : 'Post Thought' }}
        </button>
        <code v-if="editingComment && (editingComment.user === $store.state.auth.uid || ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members && $store.state.app.advanced.roles.admin.members.includes($store.state.auth.uid)))" @click="remove(commentsid || $route.params.assetId, editingComment.id)" class="flex align-center xs-font p8" style="cursor: pointer;">
          <i class="far fa-trash-alt r4"></i>Remove
        </code>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue'
import _ from "lodash";

export default {
  data() {
    return {
      test: "test",
      newComment: {},
      newResponse: {},
      lo: _,
      show: {
        expand: false,
        preview: false,
        replyToComment: null,
        pickComponents: false,
        links: false,
        embeds: false
      },
      isFormActive: false,
      values: [], // for reordering
      // Viewport-based loading
      isInView: false,
      observer: null,
      commentsLoaded: false,
      isIndividualCommentPage: false,
      commentsToShow: 9
    };
  },
  computed: {
    // comments() {
    //   return this.queryComments();
    // },
    assetId() {
      return this.commentsid || this.$route.params.assetId || this.$route.params.iitemid;
    },
    commentId() {
      return this.$route.params.commentId;
    },
    filteredComments() {
      const comments = this.$store.state.comments[this.assetId];
      if (!comments) {
        return [];
      }

      const orderedComments = this.orderByDate(comments);

      // If we have a specific comment ID, show only that comment (replies will be shown via nested comments component)
      if (this.commentId) {
        const targetComment = orderedComments.find(comment => comment && comment.id === this.commentId);
        if (targetComment) {
          return [targetComment];
        }
      }

      // Show last N comments (newest first, so slice from end)
      return orderedComments.slice(-this.commentsToShow);
    },
    hasMoreComments() {
      const comments = this.$store.state.comments[this.assetId];
      if (!comments) return false;
      const orderedComments = this.orderByDate(comments);
      return orderedComments.length > this.commentsToShow;
    },
    hasContent() {
      return this.hasContentForComment(this.assetId);
    },
    showActionButtons() {
      if (this.editingComment) {
        return true;
      }
      return this.isFormActive || this.hasContent;
    },
    editingCommentId() {
      const commentEdit = this.$store.state.show.commentEdit;
      // Return null if commentEdit is falsy or an empty object
      return (commentEdit && typeof commentEdit === 'object' && Object.keys(commentEdit).length === 0) ? null : commentEdit;
    },
    editingComment() {
      if (!this.editingCommentId) return null;
      const comments = this.$store.state.comments[this.assetId];
      if (!comments) return null;
      return comments[this.editingCommentId] || null;
    },
    currentFormComment() {
      if (this.editingComment) {
        return this.editingComment;
      }
      this.initCommentData(this.assetId);
      return this.newComment[this.assetId];
    },
    currentFormCommentId() {
      if (this.editingComment) {
        return this.editingComment.id;
      }
      return this.assetId;
    },
    hasContentForCurrentForm() {
      const comment = this.currentFormComment;
      if (!comment) return false;
      return (comment.text && comment.text.trim().length > 0) ||
        (comment.components && comment.components.length > 0) ||
        (comment.media && comment.media.length > 0) ||
        (comment.links && comment.links.length > 0) ||
        (comment.embeds && comment.embeds.trim().length > 0);
    }
  },
  methods: {
    // Initialize comment data for a specific ID
    initCommentData(id) {
      if (!this.newComment[id]) {
        this.$set(this.newComment, id, {
          type: "comment",
          text: "",
          published: true,
          media: [],
          components: [],
          links: [],
          embeds: ""
        });
      }
    },

    // Check if a specific comment has content
    hasContentForComment(id) {
      if (this.editingComment && this.editingComment.id === id) {
        const comment = this.editingComment;
        return (comment.text && comment.text.trim().length > 0) ||
          (comment.components && comment.components.length > 0) ||
          (comment.media && comment.media.length > 0) ||
          (comment.links && comment.links.length > 0) ||
          (comment.embeds && comment.embeds.trim().length > 0);
      }
      this.initCommentData(id);
      const comment = this.newComment[id];
      return (comment.text && comment.text.trim().length > 0) ||
        (comment.components && comment.components.length > 0) ||
        (comment.media && comment.media.length > 0) ||
        (comment.links && comment.links.length > 0) ||
        (comment.embeds && comment.embeds.trim().length > 0);
    },

    // Clear comment data for a specific ID
    clearCommentData(id) {
      if (this.newComment[id]) {
        this.newComment[id].text = '';
        this.newComment[id].components = [];
        this.newComment[id].media = [];
        this.newComment[id].links = [];
        this.newComment[id].embeds = '';
      }
      // Reset form active state when clearing
      this.isFormActive = false;
    },

    loadPreviousComments() {
      this.commentsToShow += 9;
    },
    queryComments() {
      return this.$store.dispatch("query", {
        type: "comments",
        id: this.assetId,
      });
    },
    remove(commentsid, id) {
      // Use commentsid prop or fallback to route params
      const actualCommentsId = commentsid || this.commentsid || this.$route.params.assetId;
      this.$store.dispatch("delete", {
        commentsid: actualCommentsId,
        id,
        type: "comments",
      });
    },
    post(id, comment) {
      // Takes the id of a comment or content then pushes the comment to it's respective comments array
      if (this.$store.state.auth.uid) {
        // try simple link detection for images and auto-add to media
        this.autoconvertLinks(comment);

        // Leave comment.media as-is (must contain direct URLs)

        // If this is a reply to a specific comment, use that comment's ID as parent
        const parentId = this.show.replyToComment || id;

        const fullComment = {
          type: comment.type,
          timestamp: Date.now(),
          text: comment.text,
          user: this.$store.state.auth.uid,
          published: true,
          media: comment.media || [],
          components: comment.components || [],
          links: comment.links || [],
          embeds: comment.embeds || ""
        };
        this.$store
          .dispatch("create", {
            id: parentId,
            comment: fullComment,
            type: "comments",
          })
          .then(() => {
            this.$set(
              this.$store.state.componentKeys,
              "comments",
              this.$store.state.componentKeys["comments"] + 1
            );
            // If this is a reply to a comment, open the replies UI for that comment
            if (this.show.replyToComment) {
              this.$store.commit('set', {
                keys: ['responses', this.show.replyToComment],
                val: true,
              });
            }
            // Close all open sections after posting
            this.show.pickComponents = false;
            this.show.links = false;
            this.show.embeds = false;
            this.show.preview = false;
          });
      } else {
        // Show login prompt instead of infinite loop
        this.$store.commit('set', {
          keys: ['show', 'auth'],
          val: true,
        });
      }
    },
    orderByDate(set) {
      return _.orderBy(set, "timestamp", "asc");
    },
    update(comment) {
      comment.type = "comments";
      comment["commentsid"] = this.assetId;
      // ensure components array exists and clean up helper properties
      if (comment.components) {
        comment.components.forEach(c => {
          delete c._selectedProp;
          delete c._propValue;
        });
      } else {
        comment.components = [];
      }
      // ensure links array exists
      if (!comment.links) {
        comment.links = [];
      }
      this.$store.dispatch("update", comment);
    },
    addComponent(name) {
      if (!this.newComment.components) {
        this.$set(this.newComment, 'components', []);
      }
      const newComp = { name: name, props: {}, styles: {}, _selectedProp: null, _propValue: null };
      this.newComment.components.push(newComp);
    },
    addComponentToForm(name) {
      const targetComment = this.currentFormComment;
      if (!targetComment.components) {
        this.$set(targetComment, 'components', []);
      }
      const newComp = { name: name, props: {}, styles: {}, _selectedProp: null, _propValue: null };
      targetComment.components.push(newComp);
    },
    addComponentTo(comment, name) {
      if (!comment.components) this.$set(comment, 'components', []);
      const newComp = { name: name, props: {}, styles: {}, _selectedProp: null, _propValue: null };
      comment.components.push(newComp);
    },
    togglePickComponents() {
      this.$set(this.show, 'pickComponents', !this.show['pickComponents']);
    },
    toggleLinks() {
      this.$set(this.show, 'links', !this.show['links']);
    },
    toggleEmbeds() {
      this.$set(this.show, 'embeds', !this.show['embeds']);
    },
    processEmbed(embedCode) {
      if (!embedCode) return '';

      // Return the embed code as-is
      // The Instagram embed script will handle processing
      return embedCode;
    },
    processInstagramEmbeds() {
      // Process Instagram embeds after they're rendered
      this.$nextTick(() => {
        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      });
    },
    toggleEditLinks(id) {
      this.$set(this.show, 'editLinks' + id, !this.show['editLinks' + id]);
    },
    toggleEditPickComponents(id) {
      this.$set(this.show, 'editPickComponents' + id, !this.show['editPickComponents' + id]);
    },
    moveComponent(components, index, direction) {
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= components.length) return;
      const [item] = components.splice(index, 1);
      components.splice(newIndex, 0, item);
    },
    openEditComment(comment) {
      if (comment && comment.components) {
        comment.components.forEach(c => {
          this.$set(c, '_selectedProp', null);
          this.$set(c, '_propValue', null);
        });
      }
      // Ensure links and embeds exist
      if (!comment.links) {
        this.$set(comment, 'links', []);
      }
      if (!comment.embeds) {
        this.$set(comment, 'embeds', '');
      }
      this.$store.commit('set', {
        keys: ['show', 'commentEdit'],
        val: comment.id,
      });
      this.$nextTick(() => {
        const textarea = this.$refs.editTextarea;
        if (textarea) {
          if (Array.isArray(textarea)) {
            textarea[0]?.focus?.();
          } else if (typeof textarea.focus === 'function') {
            textarea.focus();
          }
        }
      });
    },
    getPropsSummary(props) {
      if (!props || Object.keys(props).length === 0) return '';
      return Object.entries(props).map(([key, value]) => {
        if (typeof value === 'string' && value.length > 15) {
          return `${key}: "${value.substring(0, 12)}..."`;
        }
        if (typeof value === 'object' && value !== null) {
          return `${key}: {...}`
        }
        return `${key}: ${value}`;
      }).join(', ');
    },
    getPropInputType(compName, propName) {
      const prop = this.$cp[compName]?.[propName];
      if (!prop) return 'text';
      const type = prop.type;
      if (type === String) return 'text';
      if (type === Boolean) return 'checkbox';
      if (type === Number) return 'number';
      if (type === Object || type === Array) return 'textarea';
      return 'text';
    },
    updateComponentProp(component, propName, value) {
      if (!component.props) this.$set(component, 'props', {});
      this.$set(component.props, propName, value);
    },
    getReplyCount(commentId) {
      // First check if we have the count cached
      if (this.$store.state.commentCounts[commentId] !== undefined) {
        return this.$store.state.commentCounts[commentId];
      }
      // If we have the full comments loaded, use that
      if (this.$store.state.comments[commentId]) {
        const count = Object.keys(this.$store.state.comments[commentId]).length;
        // Cache the count to avoid repeated queries
        this.$set(this.$store.state.commentCounts, commentId, count);
        return count;
      }
      // Load count when comment is in view
      this.$store.dispatch("query", { type: "commentCounts", id: commentId });
      return 0;
    },
    loadReplies(commentId) {
      // Load replies for a specific comment when user clicks to expand
      if (!this.$store.state.comments[commentId]) {
        this.$store.dispatch("query", { type: "comments", id: commentId }).then(() => {
          // Update the count after loading replies
          const count = Object.keys(this.$store.state.comments[commentId] || {}).length;
          this.$set(this.$store.state.commentCounts, commentId, count);
        });
      }
    },
    removeMedia(index) {
      this.newComment.media.splice(index, 1);
    },
    toggleReplyForm(commentId) {
      if (this.show.replyToComment === commentId) {
        // Close the form
        this.show.replyToComment = null;
      } else {
        // Open the form
        this.show.replyToComment = commentId;
        // Initialize comment data for this specific comment ID
        this.initCommentData(commentId);
        this.$nextTick(() => {
          const textarea = this.$refs[`replyTextarea_${commentId}`];
          if (textarea) {
            if (Array.isArray(textarea)) {
              textarea[0]?.focus?.();
            } else if (typeof textarea.focus === 'function') {
              textarea.focus();
            }
          }
        });
      }
    },
    showReplyForm(commentId) {
      this.show.replyToComment = commentId;
      this.newComment.text = '';
      this.newComment.media = [];
      this.newComment.links = [];
      this.$nextTick(() => {
        const textarea = this.$refs[`replyTextarea_${commentId}`];
        if (textarea) {
          if (Array.isArray(textarea)) {
            textarea[0]?.focus?.();
          } else if (typeof textarea.focus === 'function') {
            textarea.focus();
          }
        }
      });
    },
    handleKeydown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
        event.preventDefault();
        if (this.hasContentForCurrentForm) {
          if (this.editingComment) {
            this.update(this.editingComment);
            this.$store.commit('set', {
              keys: ['show', 'commentEdit'],
              val: false,
            });
            this.show.pickComponents = false;
            this.show.links = false;
            this.show.embeds = false;
            this.show.preview = false;
          } else {
            this.post(this.assetId, this.currentFormComment);
            this.clearCommentData(this.assetId);
            this.show.pickComponents = false;
            this.show.links = false;
            this.show.embeds = false;
            this.show.preview = false;
          }
        }
      }
    },
    autoconvertLinks(comment) {
      if (!comment || !comment.text) return;
      // Match both http/https URLs and data URLs
      const urlRegex = /(https?:\/\/[^\s]+|data:[^\s]+)/g;
      let m;
      const detectedLinks = [];
      let newText = comment.text;

      while ((m = urlRegex.exec(comment.text)) !== null) {
        const u = m[0];
        // Check if this is a standalone link (surrounded by whitespace or start/end of string)
        const beforeMatch = m.index === 0 || /\s/.test(comment.text[m.index - 1]);
        const afterMatch = m.index + u.length === comment.text.length || /\s/.test(comment.text[m.index + u.length]);

        if (beforeMatch && afterMatch) {
          // This is a standalone link - add to links array and remove from text
          detectedLinks.push(u);
          newText = newText.replace(u, '').replace(/\s+/g, ' ').trim();
        } else {
          // This is part of text content - handle as before
          if (u.match(/\.(png|jpe?g|gif|webp)(\?.*)?$/i)) {
            if (!comment.media) comment.media = [];
            // avoid duplicates
            if (comment.media.indexOf(u) === -1) comment.media.push(u);
          }
        }
      }

      // Update comment with processed text and links
      if (detectedLinks.length > 0) {
        if (!comment.links) comment.links = [];
        detectedLinks.forEach(link => {
          if (comment.links.indexOf(link) === -1) comment.links.push(link);
        });
        comment.text = newText;
      }
    },
    setupIntersectionObserver() {
      if (!window.IntersectionObserver) {
        // Fallback for older browsers - load comments immediately
        this.loadComments();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.commentsLoaded) {
            this.isInView = true;
            this.loadComments();
          }
        });
      }, {
        rootMargin: '50px 0px', // Load 50px before entering viewport
        threshold: 0.1
      });

      // Observe the comments container
      this.$nextTick(() => {
        if (this.$el && this.observer) {
          this.observer.observe(this.$el);
        }
      });
    },
    cleanupIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    loadComments() {
      if (this.commentsLoaded) return;

      const assetId = this.assetId;

      this.$store.dispatch("query", { type: "comments", id: assetId });
      this.commentsLoaded = true;
    },
    unloadComments() {
      if (!this.commentsLoaded) return;

      const assetId = this.assetId;
      // Stop Firebase listener and clear comments
      this.$store.dispatch('stopComments', { id: assetId });

      this.commentsLoaded = false;
    },
    onPropSelect(comp) {
      if (comp._selectedProp) {
        comp._propValue = comp.props[comp._selectedProp] || '';
      }
    },
    saveProp(comp) {
      if (comp._selectedProp && comp._propValue !== undefined) {
        this.$set(comp.props, comp._selectedProp, comp._propValue);
        comp._selectedProp = null;
        comp._propValue = null;
      }
    },
    saveComponentStyles(comp) {
      try {
        comp.styles = JSON.parse(comp._stylesText || '{}');
      } catch (e) {
        console.error('Invalid JSON for styles:', e);
      }
    },
    adjustTextareaHeight(event) {
      this.$nextTick(() => {
        let textarea;

        // If event is provided, use the target textarea
        if (event && event.target) {
          textarea = event.target;
        } else {
          // Otherwise, use the main reply textarea
          textarea = this.$refs.replyTextarea;
        }

        if (textarea) {
          // Reset height to auto to get the correct scrollHeight
          textarea.style.height = 'auto';

          // Calculate the number of lines
          const lineHeight = 20; // Approximate line height in pixels
          const minHeight = lineHeight; // 1 line
          const maxHeight = lineHeight * 8; // 8 lines

          // Calculate content height
          const contentHeight = textarea.scrollHeight;

          // Set height based on content, with min/max constraints
          if (contentHeight <= minHeight) {
            textarea.style.height = minHeight + 'px';
          } else if (contentHeight <= maxHeight) {
            textarea.style.height = contentHeight + 'px';
          } else {
            textarea.style.height = maxHeight + 'px';
          }
        }
      });
    },
  },
  created() {
    // const assetId = this.commentsid || this.$route.params.assetId || this.$route.params.iitemid;
    // const commentId = this.$route.params.commentId;

    // Don't load comments immediately - wait for intersection observer
    // this.$store.dispatch("query", { type: "comments", id: assetId });
    // Comment counts are now loaded on-demand in getReplyCount method
  },
  mounted() {
    // Initialize comment data for the main asset
    this.initCommentData(this.assetId);

    // Check if this is an individual comment page
    this.isIndividualCommentPage = this.$route && this.$route.name === 'comments' && this.$route.params && this.$route.params.commentId;

    // Only load comments for top-level components or individual comment pages
    // Nested comments (depth > 0) should not load comments to prevent infinite loops
    if (!this.depth || this.depth === 0 || this.isIndividualCommentPage) {
      this.loadComments();
    }

    // Auto-open reply form for individual comment pages
    if (this.isIndividualCommentPage && this.$route.params.commentId) {
      this.show.replyToComment = this.$route.params.commentId;
    }

    // Initialize textarea height
    this.adjustTextareaHeight();

    // Load Instagram embed script if not already loaded
    if (!window.instgrm) {
      const script = document.createElement('script');
      script.src = '//www.instagram.com/embed.js';
      script.async = true;
      script.onload = () => {
        // Process Instagram embeds after script loads
        this.processInstagramEmbeds();
      };
      document.head.appendChild(script);
    } else {
      // Script already loaded, process embeds
      this.processInstagramEmbeds();
    }
  },
  beforeDestroy() {
    this.cleanupIntersectionObserver();
  },
  name: "comments",
  props: { depth: { type: [Number, String] }, commentsid: { type: String } },
  watch: {
    assetId: {
      handler(newAssetId) {
        if (newAssetId) {
          this.initCommentData(newAssetId);
        }
      },
      immediate: true
    },
    "$route.params.commentId": {
      handler(newCommentId, oldCommentId) {
        if (newCommentId && newCommentId !== oldCommentId) {
          // Load replies for the new comment
          this.$store.dispatch("query", { type: "comments", id: newCommentId });
          // Auto-expand replies for individual comment pages
          this.$store.commit('set', {
            keys: ['responses', newCommentId],
            val: true,
          });
          // Auto-open reply form for individual comment pages
          this.show.replyToComment = newCommentId;
        }
      },
      immediate: false
    },
    comments: {
      handler() {
        // Process Instagram embeds when comments are loaded/updated
        this.processInstagramEmbeds();
      },
      deep: true
    }
  },
};
</script>
<style>
.comment-meta {
  margin: 8px 4px;
}

/* .comment-text {
  color: black;
  padding: 4px 8px;
  box-shadow: 0 2px 1px black;
  margin: 8px;
} */

.comments_container {
  /* max-width: 560px;
  min-width: 270px; */
  position: relative;
}

/* Ensure comment interactions stay at bottom and are visible */
.comment-interactions {
  position: relative;
  z-index: 9;
}

/* Ensure embeds don't overlap with interactions */
.comment_area {
  position: relative;
  z-index: 1;
}

/* Ensure comment content is behind admin and profile popups */
.comments_container {
  position: relative;

}

.response {
  margin: 0 0 1px 0;
}

.response textarea {
  min-height: 96px;
}

.response button {
  min-height: 46px;
}

.response-actions {
  margin: 8px;
  min-width: 96px;
}

/* Thought box animations */
.thought-box-enter-active,
.thought-box-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  transform-origin: top;
}

.thought-box-enter,
.thought-box-leave-to {
  opacity: 0;
  transform: scaleY(0) scaleX(0.8);
  max-height: 0;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.thought-box-enter-to,
.thought-box-leave {
  opacity: 1;
  transform: scaleY(1) scaleX(1);
  max-height: 1000px;

}

/* Thought button animations */
.thought-button {
  position: relative;
  overflow: hidden;
}

.thought-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.thought-button:hover::before {
  left: 100%;
}

.thought-button.active {
  transform: scale(1.05);
  background: rgba(0, 123, 255, 0.1);

}

.thought-button.active i {
  transform: rotate(-90deg);
  transition: all 0.3s ease;
}

/* Thought reply form styling */
.thought-reply-form {
  position: relative;
  overflow: hidden;
}

.thought-reply-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

/* Unified Post Area Styles */
.unified-post-area {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.post-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-label {
  font-weight: bold;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-content {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  min-height: 60px;
}

.comment-text {
  margin-bottom: 8px;
}

.comment-components {
  margin: 8px 0;
}

.comment-media {
  margin: 8px 0;
}

.comment-links {
  margin: 8px 0;
}

.comment-link {
  margin: 4px 0;
}

.comment-link-item {
  color: #007bff;
  text-decoration: none;
}

.comment-link-item:hover {
  text-decoration: underline;
}

.comment-embeds {
  margin: 8px 0;
}

/* Dynamic textarea styles */
.dynamic-textarea {
  transition: height 0.2s ease;
  line-height: 20px;
  font-size: 14px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  outline: none;
}

.dynamic-textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
</style>
